// FormControlEmployee component

import React from "react";
import { FormControl, FormLabel, FormErrorMessage } from "@chakra-ui/react";
import Select from "react-select";
import {
  newBorder,
  white,
  primary,
  textPrimary,
  textSecondary,
  backgroundLight,
  hoverItemColor,
} from "../../utils/colors";
import { useTranslation } from "react-i18next";
import { borderRadius, shade } from "polished";

const FormControlGender = ({
  label,
  value,
  onChange,
  isRequired,
  isTouched,
  isError,
  errorMessage,
  w,
  isSmall,
  isMulti,
  placeholder,
  noBottom,
  labelFontSize,
  zIndex = 1000,
}) => {
  // TRANSLATION
  const { t } = useTranslation();

  // Hardcoded options for tenant type
  const options = [
    { value: "female", label: t("patient.detailsGenderFemale") },
    { value: "male", label: t("patient.detailsGenderMale") },
    // { value: "other", label: t("patient.detailsGenderOther") },
  ];

  // Find the selected option based on the current value
  // const selectedOption =
  //   options.find((option) => option.value === value) || null;

  const selectedOption =
    options.find((option) => option.value === value) || null;
  // const filteredOptions = options.filter((option) => option.value !== value);

  // console.log("value", value);
  // console.log("selectedOption", selectedOption);

  // Custom styles for react-select
  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      color: "#718096", // Change this to your desired placeholder color
    }),
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: isError ? "red" : state.isFocused ? newBorder : newBorder,
      backgroundColor: white,
      border: `1px solid ${newBorder}`,
      fontSize: isSmall ? "0.875rem" : "0.938rem",
      fontWeight: "500",
      minHeight: isSmall ? "2.5rem" : "3rem",
      height: isMulti ? "initial" : isSmall ? "2.5rem" : "3rem",
      margin: "0",
      padding: "0 8px",
      borderRadius: "0.75rem",

      ":focus-visible": {
        borderColor: primary,
        boxShadow: `0 0 0 1px ${newBorder}`,
      },
      ":hover": {
        boxShadow: "none",
        outline: "none",
        cursor: "pointer",
        borderColor: "#cbd5e0",
      },
    }),

    menu: (provided) => ({
      ...provided,
      borderRadius: "0.75rem",
      boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.3)",
      border: `0px solid ${newBorder}`,
      overflow: "hidden",
      zIndex: 90000,
    }),

    menuList: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
      border: "none",
      boxShadow: "none",
    }),

    singleValue: (provided, state) => ({
      ...provided,
      opacity: state.isDisabled ? 0.5 : 1,
      color: textPrimary,
      margin: "0",
      padding: "0 0px",

      ":hover": {
        bg: "red",
      },
    }),

    option: (provided, state) => ({
      ...provided,

      // backgroundColor: state.isFocused ? backgroundLight : null,
      backgroundColor: state.isSelected ? primary : white, // Background color of selected option
      // color: state.isFocused ? textPrimary : state.data.color,
      color: state.isSelected ? "white" : textSecondary, // Color of text in options
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      margin: "0",
      padding: "0 1rem",
      fontWeight: "500",
      height: "48px",
      fontSize: "0.875rem",
      borderBottom: `1px solid ${newBorder}`,
      ":hover": {
        backgroundColor: state.isSelected
          ? shade(0.1, primary)
          : hoverItemColor,
        color: state.isSelected ? "white" : textPrimary,
      },
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: primary,
      color: white,
      fontSize: "0.938rem",
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: state.data.color,
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      ":hover": {
        backgroundColor: state.data.bgDark,
        color: state.data.color,
      },
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontSize: "11px",
      color: textSecondary,
      fontWeight: "500",
    }),
  };

  // console.log("value", value);
  // console.log("selectedOption", selectedOption);

  return (
    <FormControl
      mb={noBottom ? 0 : 4}
      isRequired={isRequired}
      isInvalid={isTouched && isError}
      w={w}
      zIndex={zIndex} // Set zIndex to 1000 by default if not provided
    >
      <FormLabel
        fontSize={labelFontSize ? labelFontSize : "sm"}
        position="relative"
      >
        {label}
        {isError && isTouched && (
          <FormErrorMessage fontSize="xs">{errorMessage}</FormErrorMessage>
        )}
      </FormLabel>
      <Select
        isMulti={isMulti}
        isSearchable={false}
        value={selectedOption}
        onChange={onChange}
        // options={filteredOptions}
        options={options}
        placeholder={placeholder}
        styles={customStyles}
      />
    </FormControl>
  );
};

export default FormControlGender;
